import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Box, Container } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { getUsuarios } from "../../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import FitroInformeGeneralComponents from "../../../../components/FitroInformeGeneralComponents";
import { Delete } from "@mui/icons-material";



function InformeGeneralPage() {
    const [name, setName] = useState('');
    const [beneficiario, setBeneficiario] = useState('');
    const [apellido, setApellido] = useState('');
    const [cedula, setCedula] = useState('');
    const [estado, setEstado] = useState('');
    const [items, setItems] = useState('');
    const [tipo, setTipo] = useState('');
    const [userTester, setUserTester] = useState('');
    const [loading, setLoading] = useState(false);
    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');



    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);



    console.log("stateToken", stateToken);
    useEffect(() => {
        if (stateToken?.token) {
            handleListarUsuarios();
        }
    }, [stateToken]);

    const handleListarUsuarios = () => {

        getUsuarios(stateToken?.token, 1, 10)
            .then((response) => {
                console.log("response-getUsuarios", response);
                if (response.data.length > 0) {
                    setDataUsuarios(response.data);
                    setLoading(true);
                } else {
                    setDataUsuarios([]);
                    setLoading(true);
                }
            })
            .catch((error) => {
                console.log("error-getUsuarios", error);
                setDataUsuarios([]);
                setLoading(true);
            });
    };



    //=============================================funcion para capturar el name y cedula
    const handleName = (e) => {
        setName(e);
    };

    //=============================================funcion para capturar el beneficiario
    const handleBeneficiario = (e) => {
        setBeneficiario(e);
    };

    //=============================================funcion para capturar el apellido
    const handleApellido = (e) => {
        setApellido(e);
    }

    //=============================================funcion para capturar el cedula
    const handleCedula = (e) => {
        setCedula(e);
    }




    //=============================================funcion para seleccionar el estado
    const handleEstado = (event) => {
        console.log("event", event);
        setEstado(event);
    };

    //=============================================funcion para seleccionar el estado de verificado por email
    const handleItems = (event) => {
        console.log("event", event);
        setItems(event);
    };




    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);
    };

    //=============================================funcion para seleccionar la fecha fin
    const handleFechaFin = (event) => {
        console.log("event", event);
        setFechaFin(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        console.log("fecha", fecha);
        setFechaFinBackend(fecha);
    };


    //=============================================funcion para seleccionar el user tester
    const handleUserTester = (event) => {
        console.log("event", event);
        setUserTester(event);
    };


    

    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataUsuarios(dataUsuarios.filter((row) => row.id !== id));
    }


    const columns = [
        {
            field: 'id',
            headerName: 'Creado el',
            flex: 0.5
        },
        {
            field: 'name',
            headerName: 'Promoción',
            editable: true,
            flex: 1
        },
        {
            field: 'descripcion',
            headerName: 'subCategoría',
            editable: true,
            flex: 1
        },
        {
            field: 'name',
            headerName: 'Cliente',
            editable: false,
            flex: 1
        },
        {
            field: 'email',
            headerName: 'Cédula',
            editable: false,
            flex: 1
        },
        {
            field: 'status',
            headerName: 'Beneficiario',
            editable: false,
            flex: 1
        },
        {
            field: 'verificadoPorEmail',
            headerName: 'Nro Factura',
            editable: false,
            flex: 1
        },
        {
            field: 'perteneceComplejo',
            headerName: 'Es Itau',
            editable: false,
            flex: 1
        },
        {
            field: 'fechaFactura',
            headerName: 'Fecha Factura',
            editable: false,
            flex: 1
        },
        {
            field: 'local',
            headerName: 'Local',
            editable: false,
            flex: 1
        },
        {
            field: 'cupones',
            headerName: 'Cupones',
            editable: false,
            flex: 1
        },
        {
            field: 'articulos',
            headerName: 'Articulos',
            editable: false,
            flex: 1
        },
        {
            field: 'monto',
            headerName: 'Monto',
            editable: false,
            flex: 1
        },
        {
            field: 'creadoPor',
            headerName: 'Creado por',
            editable: false,
            flex: 1
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
              return [
                <GridActionsCellItem
                  icon={<Delete />}
                  label="Delete"
                  onClick={handleDeleteClick(id)}
                  color="inherit"
                />,
              ];
            },
          },
    ];


    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>
                {loading ? (
                    <div>
                        <FitroInformeGeneralComponents
                            name={name}
                            handleName={handleName}

                            beneficiario={beneficiario}
                            handleBeneficiario={handleBeneficiario}

                            apellido={apellido}
                            handleApellido={handleApellido}

                            cedula={cedula}
                            handleCedula={handleCedula}


                            fechaInicio={fechaInicio}
                            handleFechaInicio={handleFechaInicio}

                            fechaFin={fechaFin}
                            handleFechaFin={handleFechaFin}

                            userTester={userTester}
                            handleUserTester={handleUserTester}
                        />

                        <div style={{
                            backgroundColor: PaletaColor.BLANCO,
                            borderRadius: Padding.P1,
                            padding: Padding.P3,
                        }}>
                            <Box sx={{ width: '100%' }}>
                                <DataGrid
                                    rows={dataUsuarios}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    // checkboxSelection
                                    disableRowSelectionOnClick
                                />
                            </Box>
                        </div>
                    </div>
                ) : (
                    <Container sx={{}} style={{}}>
                        <SkeletonLoading />
                    </Container>
                )}


            </div>
        </HeaderCustom>
    );
}

export default InformeGeneralPage;